import { Modal, Form, Button, Dropdown } from 'react-bootstrap';
import { Camera, Globe, Type, AtSign, X, ImageIcon } from 'lucide-react';

export default function CreatePostModal({ show, onHide, userName }) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header className="border-bottom">
        <Modal.Title className="fw-bold">Create a post</Modal.Title>
        <Button variant="link" className="p-0 border-0 text-muted" onClick={onHide}>
          <X size={24} />
        </Button>
      </Modal.Header>
      
      <Modal.Body className="p-3">
        <div className="d-flex gap-2 mb-3">
          <div className="rounded-circle bg-light" style={{ width: '40px', height: '40px' }}>
            <div className="w-100 h-100 d-flex align-items-center justify-content-center text-muted">
              👤
            </div>
          </div>
          <div>
            <h6 className="mb-1">{userName}</h6>
            <Dropdown>
              <Dropdown.Toggle variant="light" size="sm" className="d-flex align-items-center gap-1">
                <Globe size={14} />
                Public
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item active>Public</Dropdown.Item>
                <Dropdown.Item>Friends</Dropdown.Item>
                <Dropdown.Item>Only me</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <Form>
          <Form.Control
            as="textarea"
            placeholder={`Share what's on your mind, ${userName}...`}
            className="border-0 p-0"
            style={{ minHeight: '150px', resize: 'none' }}
          />
        </Form>
      </Modal.Body>

      <Modal.Footer className="border-top">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex gap-2">
            <Button variant="link" className="p-1 text-muted">
              <ImageIcon size={20} />
            </Button>
            <Button variant="link" className="p-1 text-muted">
              <Type size={20} />
            </Button>
            <Button variant="link" className="p-1 text-muted">
              <AtSign size={20} />
            </Button>
          </div>
          <Button variant="primary" className="px-4">
            Post
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
